<template>
  <div class="row">
    <spinner v-if="loading.referralEmails"></spinner>
    <form v-else data-vv-scope="email-settings">
      <div class="col-md-5">
        <form-select
          v-model="currentType"
          label="Select email type"
          name="email-type"
          validation-scope="email-settings"
          validators="required"
          :options="types"
        />
      </div>
      <div class="col-md-7">
        <shortcodes-editor
            v-model="data[currentType]"
            label="Body"
            name="body"
            validation-scope="new-email"
            validators="required"
            rows="20"
            :shortcodes="shortcodes"
          />
      </div>
      <div class="col-md-12">
        <button class="btn green" @click.prevent="save()">Save</button>
      </div>
    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

import Spinner from "@/components/Spinner";
import FormInput from "@/components/forms/FormInput";
import FormSelect from "@/components/forms/FormSelect";
import ImageRender from "@/components/formbuilder/render/ImageRender";
import ShortcodesEditor from "@/components/forms/ShortcodesEditor";
import VueSelect from 'vue-select';

export default {
  components: {
    Spinner,
    FormInput,
    FormSelect,
    ImageRender,
    ShortcodesEditor,
    VueSelect,
  },
  props: {
    formId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      currentType: 'emailBody',
      shortcodes: ['first_name','last_name','email', 'organization_name'],
      types: [{
        id: 'emailBody',
        label: 'Registered',
      }, {
        id: 'completedEmailBody',
        label: 'Completed',
      }]
    }
  },
  computed: {
    ...mapGetters({
      data: 'emails/getReferralEmails',
      loading: 'emails/getLoading',
    }),
  },
  methods: {
    async save() {
      if (await this.$validator.validateAll('email-settings')) {
        this.updateReferralEmails({
          formId: this.formId,
          ...this.data
        }).then(() => {
          this.$notify('Changes saved!');
        });
      }
    },
    ...mapActions({
      fetchReferralEmails: 'emails/fetchReferralEmails',
      updateReferralEmails: 'emails/updateReferralEmails',
    })
  },
  mounted() {
    this.fetchReferralEmails({
      formId: this.formId
    });
  }
}
</script>



// WEBPACK FOOTER //
// ReferralEmailSettings.vue?623f4635